{
    "walk-one-hour": "Continue",
    "your-family": "Yours",
    "you": "you",
    "wife": "wife",
    "son": "son",
    "daughter": "daughter",
    "bag-is-empty": "Bag"
}
